import { EMPTY_FLIGHTS, cleanFlights, flightsToForm, flightErrors } from "@/lib/flights";

const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[A-Za-z]{2,}$/;
const AMOUNT_RE = /^\d{1,7}(\.\d{1,2})?$/;
const RATE_RE = /^\d{1,6}(\.\d{1,4})?$/;

export const toCents = (v) => {
  const s = String(v ?? "").trim();
  if (!AMOUNT_RE.test(s) || Number(s) <= 0) return null;
  return Math.round(Number(s) * 100);
};
export const planLocked = (f) => { const t = toCents(f.total_amount), i = toCents(f.initial_payment); return t != null && i != null && t > i; };
export const withPlan = (f) => (planLocked(f) ? { ...f, amount: (toCents(f.initial_payment) / 100).toFixed(2) } : f);
export const balanceCents = (f) => { const t = toCents(f.total_amount), a = toCents(f.amount); return t != null && a != null && t >= a ? t - a : null; };

export const EMPTY_FORM = {
  guest_name: "", email: "", phone: "", room: "", adults: "", minors: "", infants: "",
  check_in: "", check_out: "", resort_credits: "", transportation: "", additional_services: "",
  amount: "", processor_id: "", expires_hours: "24", delivery_mode: "manual", currency: "USD", total_amount: "", initial_payment: "", exchange_rate: "", manual_url: "", language: "", group_id: "", property_name: "", flights: EMPTY_FLIGHTS,
};

const clean = (v) => (typeof v === "string" && v.trim() ? v.trim() : null);
const toInt = (v) => (String(v ?? "").trim() === "" ? null : /^\d+$/.test(String(v).trim()) ? parseInt(v, 10) : NaN);

export function validateCharge(form, strict) {
  const e = flightErrors(form.flights);
  if (clean(form.email) && !EMAIL_RE.test(form.email.trim())) e.email = "Correo electrónico no válido";
  ["adults", "minors", "infants"].forEach((f) => {
    const n = toInt(form[f]);
    if (Number.isNaN(n)) e[f] = "Debe ser un número entero no negativo";
    else if (strict && n === null && f !== "infants") e[f] = "Selecciona una cantidad";
  });
  if (form.check_in && form.check_out && form.check_out <= form.check_in) e.check_out = "El Check-Out debe ser posterior al Check-In";
  const amt = clean(form.amount);
  if (amt) {
    if (!AMOUNT_RE.test(amt)) e.amount = "Monto no válido (máximo dos decimales)";
    else if (Number(amt) <= 0) e.amount = "El monto debe ser mayor que cero";
  }
  ["total_amount", "initial_payment"].forEach((f) => {
    if (clean(form[f]) && toCents(form[f]) == null) e[f] = "Monto no válido (mayor que cero, máximo dos decimales)";
  });
  const t = toCents(form.total_amount), i = toCents(form.initial_payment), a = toCents(form.amount);
  if (t != null && i != null && i > t && !e.initial_payment) e.initial_payment = "El pago inicial no puede ser mayor que el monto total";
  if (t != null && a != null && a > t && !e.amount) e.amount = "El monto a cobrar no puede ser mayor que el monto total";
  const rate = clean(form.exchange_rate);
  if (rate && (!RATE_RE.test(rate) || Number(rate) <= 0)) e.exchange_rate = "Tipo de cambio no válido (máximo 4 decimales)";
  if (strict) {
    const req = {
      guest_name: "El nombre del huésped es obligatorio", email: "El correo es obligatorio",
      amount: "El monto es obligatorio", processor_id: "Selecciona un procesador",
    };
    Object.entries(req).forEach(([f, m]) => { if (!clean(form[f]) && !e[f]) e[f] = m; });
    if (form.processor_id === "manual" && !clean(form.manual_url)) e.manual_url = "Pega el enlace de pago";
  }
  if (form.processor_id === "manual" && clean(form.manual_url) && !/^https?:\/\/\S+$/i.test(form.manual_url.trim())) e.manual_url = "Enlace no válido (debe iniciar con https://)";
  return e;
}

export function toPayload(form, hotelSlug) {
  const p = { hotel_slug: hotelSlug, expires_hours: parseInt(form.expires_hours || "24", 10), delivery_mode: form.delivery_mode || "manual", currency: form.currency || "USD", language: form.language || null };
  ["guest_name", "email", "phone", "room", "check_in", "check_out", "resort_credits", "transportation", "additional_services", "amount", "processor_id", "total_amount", "initial_payment", "exchange_rate", "manual_url", "group_id", "property_name"]
    .forEach((f) => { p[f] = clean(form[f]); });
  ["adults", "minors", "infants"].forEach((f) => { p[f] = toInt(form[f]); });
  p.flights = cleanFlights(form.flights);
  return p;
}

export function chargeToForm(c) {
  const f = { ...EMPTY_FORM };
  Object.keys(EMPTY_FORM).forEach((k) => { if (k !== "flights" && c[k] !== null && c[k] !== undefined) f[k] = String(c[k]); });
  f.flights = flightsToForm(c.flights);
  return f;
}

export function formToTemplate(form, processorName) {
  const n = (v) => { const x = toInt(v); return Number.isNaN(x) ? null : x; };
  const amt = clean(form.amount);
  const cents = amt && AMOUNT_RE.test(amt) && Number(amt) > 0 ? Math.round(Number(amt) * 100) : null;
  return {
    guest_name: clean(form.guest_name), property_name: clean(form.property_name), room: clean(form.room), adults: n(form.adults), minors: n(form.minors), infants: n(form.infants),
    check_in: clean(form.check_in), check_out: clean(form.check_out), resort_credits: clean(form.resort_credits),
    transportation: clean(form.transportation), additional_services: clean(form.additional_services),
    amount_cents: cents, currency: form.currency || "USD",
    total_cents: toCents(form.total_amount), initial_cents: toCents(form.initial_payment), balance_cents: balanceCents(form),
    exchange_rate: clean(form.exchange_rate), processor_name: processorName || null, flights: cleanFlights(form.flights),
  };
}
